const subcategoryDetailsSymbols = {
  GET_SUBCATEGORY_DETAILS: "GET_SUBCATEGORY_DETAILS",
  GET_SUBCATEGORY_DETAILS_SUCCESS: "GET_SUBCATEGORY_DETAILS_SUCCESS",
  GET_SUBCATEGORY_DETAILS_FAILURE: "GET_SUBCATEGORY_DETAILS_FAILURE",
  CLEAR_GET_SUBCATEGORY_DETAILS: "CLEAR_GET_SUBCATEGORY_DETAILS"
};

export default subcategoryDetailsSymbols; 